import AddIcon from "@mui/icons-material/Add";
import TuneIcon from "@mui/icons-material/Tune";
import {
  Box,
  Container,
  FormHelperText,
  Grid,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { uniq } from "lodash";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import { default as CustomSelect } from "../../../components/Select/Select";
import {
  enableCheckoutByAppointmentId,
  getClinicPaymentsByFilter,
  getClinicPaymentsForSuggestion,
  updateBalanceDueAndStatusByPaymentId,
  updatePayment,
} from "../../../redux/reducers/clinicSlice";
import { getPaymentMethods } from "../../../redux/reducers/paymentMethodSlice";
import {
  cancelPaymentById,
  createReturnOnBillingItems,
} from "../../../redux/reducers/paymentSlice";
import { AppColors } from "../../../util/AppColors";
import { rolesForBilling } from "../../../util/arrayList";
import {
  PaymentTypeList,
  RefundTypes,
  cancelReasons,
  paymentInvoiceTypeList,
  paymentSourceTypes,
  paymentStatusList,
  returnReasons,
} from "../../../util/dropList";
import { billingTabEnum, paymentKeyword, tabEnum } from "../../../util/enum";
import {
  getCombinedReturnedQuantity,
  getPaymentStatusAndRefund,
  getPetShopRecordBasedType,
  getPharmacyRecordBasedType,
  getRefundValuesNew,
  getRightSaluation,
  getTaxAndSubTotalAndTotal,
  getTreatmentRecordBasedType,
  roundWithSignedDiff,
} from "../../../util/function";
import { tblGrayBack } from "../../../util/object";
import { baseURL } from "../../../util/server";
import CommonPayModal from "../../CommonComponents/CommonPayModal";
import PaymentModeDropdown from "../../CommonComponents/PaymentModeDropdown";
import BillingPreview from "../../CommonScreens/BillingPreview/BillingPreview";
import { nameExpan } from "../Reports/tableHeaders";
import "./ClinicPayments.css";
import CollectionsTable from "./CollectionsTable";

const notPaidList = ["unpaid", "partiallypaid", "partially paid"];

const reqTxt = "This field is required";
const errMap = {
  personInCharge: "inChargeErr",
  refundMethod: "refundMethodErr",
  cancelReason: "reasonErr",
  cancelRemarks: "remarkErr",
  returnReason: "reasonErr",
};

const tableHeaders = [
  "petName",
  "vetName",
  "totalDue",
  "balanceDue",
  "payType",
  "paymentStatus",
  "trDate",
  "pay",
];
const pendingTableHeaders = [
  "petName",
  "vetName",
  "totalDue",
  "balanceDue",
  "payType",
  // "paymentStatus",
  "trDate",
  "pay",
];

const initialValues = { amount: "", paymentMode: null };

const initFilter = {
  visible: false,
  added: false,
  selectedList: [],
  values: {},
};
const initSearch = {
  petName: "",
  userName: "",
  vetName: "",
  status: [],
  source: [],
};
const filterByListOpen = [
  "Transaction Date",
  "Invoice Number",
  "Invoice Type",
  "Payment Mode",
  "Total Due",
  "Balance Due",
];
const filterByList = [
  "Transaction Date",
  "Invoice Number",
  "Invoice Type",
  "Payment Mode",
  "Total Due",
  "Balance Due",
  "Person In Charge",
];
const dropFields = ["Invoice Type", "Payment Mode", "Person In Charge"];
const splitRows = ["Transaction Date", "Total Due", , "Balance Due"];

const Payments = ({
  posPayId,
  setPosPayId,
  setPaymentTableType,
  paymentTableType,
  setSelectedPaymentTab,
  selectedPaymentTab,
  setSelecetdPayment,
  setPosModVsble,
  setActiveTab,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tablePayments, setTablePayments] = useState([]);
  const [payValues, setPayValues] = useState(initialValues);
  const [payErr, setPayErr] = useState({});
  const [searchText, setSearchText] = useState("");
  const [payModalVisible, setPayModalVisible] = useState(false);
  const [genBillModVsble, setGenBillModVsble] = useState(false);
  const [selectedType, setSelectedType] = useState("all");
  const [selectMode, setSelectMode] = useState("all");
  const [selectedSource, setSelectedSource] = useState("all");
  const [modalData, setModalData] = useState(null);
  const [page, setPage] = useState(1);
  const [selectedBill, setSelectedBill] = useState(null);
  const [invModVisible, setInvModVisible] = useState(false);
  const [returnModVsble, setReturnModVsble] = useState(false);
  const [returnValue, setReturnValue] = useState({});
  const [cancelValues, setCancelValues] = useState({});
  const [listNotValid, setListNotValid] = useState(false);
  const [cancelModVsble, setCancelModVsble] = useState(false);
  const [enabledPaymentTypes, setEnabledPaymentTypes] =
    useState(PaymentTypeList);
  const [totalBalanceDue, setTotalBalanceDue] = useState(0);
  const [searchValues, setSearchValues] = useState(initSearch);
  const [filterValues, setFilterValues] = useState(initFilter);
  const {
    payments,
    hugePayments,
    details: clinicDetail,
    clinicStocks: stocks,
    paymentsByFilter,
    paymentsForSuggestion,
  } = useSelector((state) => state?.clinic);
  const lastSummary = useSelector((state) => state?.pet?.lastSummary?.data);
  const paymentMethod = useSelector((state) => state?.paymentMethod);
  // const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const itemsPerLoad = 10;
  const hugeRecordSize = 50;
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { clinic: clinicData, vets: clinicVets } = useMemo(() => {
    if (!mandateDataRaw) {
      return { clinic: {}, vets: [] };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        clinic: reqData?.clinic ?? {},
        vets: Array.isArray(reqData?.vets) ? reqData?.vets : [],
      };
    } catch {
      return { clinic: {}, vets: [] };
    }
  }, [mandateDataRaw]);
  const clinicDet = clinicData?.id ? clinicData : clinicDetail;
  const isBillCombined =
    (clinicDet?.billingMode ?? "")?.toLowerCase() === "combined";

  useEffect(() => {
    // Reset filter values to initial state when component mounts
    setFilterValues({ ...initFilter, selectedList: [], values: {} });
    dispatch(getClinicPaymentsForSuggestion({ itemSize: 200, page: 1 }));
    // dispatch(getClinicStocks());
    // dispatch(getServices());
    dispatch(getPaymentMethods());
    // dispatch(getClinicVets("?type=all"));
  }, []);

  //for set the search value, data will comes from Billing dashboard
  useEffect(() => {
    if (
      // paymentTableType === "today" ||
      paymentTableType === "unpaid" &&
      selectedPaymentTab === "Finalized"
    ) {
      // if (paymentTableType === "today") {
      //   const reqObj = {
      //     ...filterValues,
      //     selectedList: [
      //       ...(filterValues?.selectedList ?? []),
      //       "Transaction Date",
      //     ],
      //     values: {
      //       ...(filterValues?.values ?? {}),
      //       "Start Date": new Date(),
      //       "End Date": new Date(),
      //     },
      //   };
      //   setFilterValues(reqObj);
      //   onPaymentsApiCall(1, false, null, reqObj);
      //   setPaymentTableType(null);
      // }
      if (paymentTableType === "unpaid") {
        const reqObj = {
          ...searchValues,
          status: [
            { name: "Unpaid", value: "unpaid" },
            { name: "Partially Paid", value: "partiallypaid" },
          ],
        };
        setSearchValues(reqObj);
        onPaymentsApiCall(1, false, reqObj);
        setPaymentTableType(null);
      }
    }
  }, [paymentTableType, selectedPaymentTab]);

  useEffect(() => {
    if (!paymentTableType) {
      onPaymentsApiCall(1);
    }
  }, [
    searchValues?.petName,
    searchValues?.userName,
    searchValues?.vetName,
    searchValues?.status,
    // searchValues?.type,
    searchValues?.source,
    paymentTableType,
  ]);

  const getFilterObj = (
    currentPage = 1,
    reset = false,
    searchObj = null,
    filterObj = null,
    tab = null,
  ) => {
    setPage(currentPage);
    const reqTab = tab ?? selectedPaymentTab;
    const reqObj = {
      page: currentPage,
      itemSize: itemsPerLoad,
      checkOut: reqTab === "Finalized" ? ["Y", "P"] : ["N"],
    };
    const srchValues = searchObj ?? searchValues;
    const filValues = filterObj ?? filterValues;
    if (reset) return reqObj;
    if (srchValues?.petName?.length > 0) reqObj.petName = srchValues?.petName;
    if (srchValues?.userName?.length > 0)
      reqObj.username = srchValues?.userName;
    if (srchValues?.vetName?.length > 0) reqObj.vetName = srchValues?.vetName;
    if (srchValues?.status?.length > 0) {
      reqObj.status = (srchValues?.status ?? [])?.some(
        (li) => li?.value === "all",
      )
        ? ["paid", "unpaid", "ppaid", "partiallypaid", "cancelled"]
        : (srchValues?.status ?? [])?.map((li) => paymentKeyword?.[li?.value]);
    }
    if ((srchValues?.source ?? [])?.length > 0) {
      reqObj.type = (srchValues?.source ?? [])?.some(
        (li) => li?.value?.toLowerCase() === "all",
      )
        ? ["Clinic", "Pharmacy", "Pet Shop"]
        : (srchValues?.source ?? [])?.map((li) => li?.value);
    }
    // if ((srchValues?.type ?? [])?.length > 0) {
    //   reqObj.type = (srchValues?.type ?? [])?.map((li) => li?.value);
    // }
    if (filValues?.selectedList?.includes("Transaction Date")) {
      reqObj.startDate = moment(
        new Date(new Date(filValues?.values?.["Start Date"] ?? new Date())),
      ).format("YYYY-MM-DD");
      if (filValues?.values?.["End Date"]) {
        reqObj.endDate = moment(
          new Date(new Date(filValues?.values?.["End Date"] ?? new Date())),
        ).format("YYYY-MM-DD");
      }
    }
    if (
      filValues?.selectedList?.includes("Invoice Number") &&
      filValues?.values?.["Invoice Number"]?.length > 0
    ) {
      reqObj.invoiceNumber = filValues?.values?.["Invoice Number"];
    }
    if (filValues?.selectedList?.includes("Total Due")) {
      reqObj.totalDueMin = Number(filValues?.values?.["Min Total Due"] ?? 0);
      reqObj.totalDueMax = Number(filValues?.values?.["Max Total Due"] ?? 0);
    }
    if (filValues?.selectedList?.includes("Balance Due")) {
      reqObj.balanceDueMin = Number(
        filValues?.values?.["Min Balance Due"] ?? 0,
      );
      reqObj.balanceDueMax = Number(
        filValues?.values?.["Max Balance Due"] ?? 0,
      );
    }
    if (
      filValues?.selectedList?.includes("Invoice Type") &&
      filValues?.values?.["Invoice Type"]?.length > 0
    ) {
      reqObj.invoiceType = filValues?.values?.["Invoice Type"]?.map(
        (li) => li?.value,
      );
    }
    if (
      filValues?.selectedList?.includes("Payment Mode") &&
      filValues?.values?.["Payment Mode"]?.length > 0
    ) {
      reqObj.paymentMode = filValues?.values?.["Payment Mode"]?.map(
        (li) => li?.value,
      );
    }
    if (
      reqTab === "Finalized" &&
      filValues?.selectedList?.includes("Person In Charge") &&
      filValues?.values?.["Person In Charge"]
    ) {
      reqObj.personInCharge = filValues?.values?.["Person In Charge"];
    }
    return reqObj;
  };

  const onPaymentsApiCall = (
    currentPage = 1,
    reset = false,
    searchObj = null,
    filterObj = null,
    tab = null,
  ) => {
    dispatch(
      getClinicPaymentsByFilter(
        getFilterObj(currentPage, reset, searchObj, filterObj, tab),
      ),
    );
  };

  const getSuggestionList = () => {
    const reqList =
      paymentsForSuggestion?.data
        ?.flatMap((obj) => [
          obj.petShopInvoiceNumber ?? "",
          obj.treatmentInvoiceNumber ?? "",
          obj.invoiceNumbers ?? "",
        ])
        ?.filter(Boolean) ?? [];
    const uniqList = uniq(reqList ?? []);
    return uniqList ?? [];
  };

  const createModalOpen = (li, balDue) => {
    setModalData(li);
    // setTotalBalanceDue(balDue);
    // if (li?.advanceAmount && Number(li?.advanceAmount) <= 0) {
    //   const filtered = PaymentTypeList.filter(
    //     (list) => list?.value !== "advanceAdjustment",
    //   );
    //   setEnabledPaymentTypes(filtered);
    // } else {
    //   setEnabledPaymentTypes(PaymentTypeList);
    // }
    // setPayValues({ ...payValues, amount: balDue });
    setPayModalVisible(true);
  };

  const filterPayments = (payments, searchText) => {
    if (!searchText) return payments;

    return payments?.filter((payment) => {
      const petNameMatch = payment?.petName
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const vetNameMatch = payment?.doctorName
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const userNameMatch = payment?.userName
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const userEmailMatch = payment?.email
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const userMobileMatch = payment?.mobile
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const paymentStatusMatch = payment?.status
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      return (
        petNameMatch ||
        vetNameMatch ||
        paymentStatusMatch ||
        userNameMatch ||
        userEmailMatch ||
        userMobileMatch
      );
    });
  };

  const handleChangeValues = (name, value) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    setPayValues({ ...payValues, [name]: value });
    const errObj = { ...payErr, [name]: reqValue?.length > 0 ? "" : reqTxt };
    if (name === "paymentMode") {
      if (reqValue !== "advanceAdjustment") {
        errObj.amount = "";
      }
      if (reqValue === "advanceAdjustment") {
        if (Number(modalData?.advanceAmount ?? 0) <= 0) {
          errObj.amount = "Insufficient credit balance";
        }
      }
    }
    if (name === "amount") {
      if (payValues?.paymentMode?.value === "advanceAdjustment") {
        errObj.amount =
          Number(value) < 0
            ? "Amount must be positive"
            : Number(value) > Number(modalData?.advanceAmount)
              ? "Insufficient credit balance"
              : "";
      } else {
        errObj.amount = Number(value) < 0 ? "Amount must be positive" : "";
      }
      if (Number(value) > totalBalanceDue) {
        errObj.amount = "Amount must be less than or equal to balance due";
      }
    }
    setPayErr(errObj);
  };

  const handleReturns = (bill) => {
    const reqObj = {
      personInCharge: null,
      returnReason: returnReasons?.[0],
      refundMethod: { name: "Advance Adjustment", value: "advanceAdjustment" },
      // list: bill?.paymentDetails
      //   ?.filter(
      //     (li) =>
      //       li?.credit === "N" &&
      //       li?.type?.toLowerCase() !== "consumables" &&
      //       li?.type?.toLowerCase() !== "administered" &&
      //       li?.quantity > 0 &&
      //       (li?.returnQuantity === 0 || !li?.returnQuantity),
      //   )
      //   ?.map((li) => ({
      //     ...li,
      //     returnQuantity: 0,
      //   })),
    };
    if (
      bill?.invoiceNumbers?.length > 0 ||
      bill?.treatmentInvoiceNumber?.length > 0 ||
      bill?.petShopInvoiceNumber?.length > 0
    ) {
      reqObj.selectedInvoiceNumber =
        bill?.tab === "petShop"
          ? bill?.petShopInvoiceNumber
          : bill?.tab === "pharmacy"
            ? bill?.invoiceNumbers
            : bill?.treatmentInvoiceNumber;
      // bill?.invoiceNumbers?.length > 0
      //   ? bill?.invoiceNumbers
      //   : bill?.treatmentInvoiceNumber?.length > 0
      //     ? bill?.treatmentInvoiceNumber
      //     : bill?.petShopInvoiceNumber?.length > 0
      //       ? bill?.petShopInvoiceNumber
      //       : "";
    }
    setReturnValue(reqObj);
    setSelectedBill(bill);
    setReturnModVsble(true);
  };

  const getPersonInChargeList = () => {
    return (clinicVets ?? [])
      ?.filter((li) => rolesForBilling.includes(li?.userRole))
      ?.map((li) => ({ name: li?.name, value: li?.doctorId }));
  };

  const onClickView = (pay, totalAmt) => {
    if (
      selectedPaymentTab === "Finalized"
      // ||
      // pay?.appointmentStatus === "completed" ||
      // pay?.status === "paid" ||
      // Number(totalAmt ?? 0) === Number(pay?.amtPaid ?? 0) ||
      // pay?.type === "Pet Shop" || //for direct billing
      // pay?.type === "Pharmacy" //for direct billing
    ) {
      // if (pay?.appointmentId) {
      //   dispatch(getCompliantSummaryByIdWoLoader(pay?.appointmentId));
      // }
      setSelectedBill(pay);
      return setInvModVisible(true);
    }
    if (!pay?.appointmentId) {
      setSelecetdPayment(pay ?? null);
      setPosModVsble(true);
      setActiveTab("PointOfSales");
      return;
    }
    if (
      pay?.appointmentStatus !== "completed"
      //  &&
      // // pay?.status !== "paid" ||
      // Number(totalAmt ?? 0) !== Number(pay?.amtPaid ?? 0)
    ) {
      return navigate("/clinic-pet-details", {
        state: {
          bill: pay,
          selectedTab: "billing",
          appointment: {
            appoinment: {
              appointmentId: pay?.appointmentId,
              petId: pay?.petId,
            },
          },
          editBill: true, //for landing to the bill directly
        },
      });
    }
  };

  const onGenerateBill = (itm, notConfirmed = true) => {
    if (notConfirmed) {
      setSelectedBill(itm);
      return setGenBillModVsble(true);
    }
    let reqUrl = "";
    if (itm?.tab === "treatment") {
      reqUrl = isBillCombined
        ? "?treatmentCheckout=Y&pharmacyCheckout=Y&petShopCheckout=Y"
        : "?treatmentCheckout=Y";
    }
    if (itm?.tab === "pharmacy") {
      reqUrl = isBillCombined
        ? "?treatmentCheckout=Y&pharmacyCheckout=Y&petShopCheckout=Y"
        : `?pharmacyCheckout=Y&treatmentCheckout=${itm?.checkOut}`;
    }
    if (itm?.tab === "petShop") {
      reqUrl = isBillCombined
        ? "?treatmentCheckout=Y&pharmacyCheckout=Y&petShopCheckout=Y"
        : `?petShopCheckout=Y&treatmentCheckout=${itm?.checkOut}`;
    }
    dispatch(
      enableCheckoutByAppointmentId({
        apntId: itm?.appointmentId,
        paymentId: itm?.paymentId,
        url: reqUrl,
        // url: "?treatmentCheckout=Y&petShopCheckout=Y&pharmacyCheckout=Y",
      }),
    ).then((res) => {
      if (res?.payload) {
        onCloseGenBillMod();
        onPaymentsApiCall(page);
      }
    });
  };

  const finalPayment = () => {
    //validation start
    let errs = {};
    if (
      !payValues?.amount ||
      isNaN(Number(payValues?.amount)) ||
      Number(payValues?.amount) <= 0 ||
      Number(payValues?.amount) > totalBalanceDue ||
      (payValues?.paymentMode?.value === "advanceAdjustment" &&
        Number(payValues?.amount) > Number(modalData?.advanceAmount))
    ) {
      errs = {
        ...errs,
        amount:
          payValues?.paymentMode?.value === "advanceAdjustment" &&
          Number(payValues?.amount) > Number(modalData?.advanceAmount)
            ? "Insufficient credit balance"
            : !payValues?.amount
              ? reqTxt
              : Number(payValues?.amount) > totalBalanceDue
                ? "Amount must be less than or equal to balance due"
                : Number(payValues?.amount) <= 0
                  ? "Amount must be positive"
                  : "",
      };
    }

    if (Number(payValues?.amount) > totalBalanceDue) {
      errs = {
        ...errs,
        amount: "Amount must be less than or equal to balance due",
      };
    }

    if (!payValues?.paymentMode?.value) {
      errs = { ...errs, paymentMode: reqTxt };
    }
    if (Object.values(errs).some((item) => item?.length > 0)) {
      return setPayErr(errs);
    }
    //validation end here
    const data = {
      paymentId: modalData.paymentId,
      paymentMode: payValues?.paymentMode?.value,
      paymentAmount: Number(payValues?.amount),
    };
    dispatch(updatePayment(data)).then(async (res) => {
      if (res?.payload) {
        onPaymentsApiCall(1);
        setPayModalVisible(false);
        setPayValues(initialValues);
        setTotalBalanceDue(0);
        handleInvModClose();
        setPayErr({});
        setModalData(null);
      }
    });
  };

  const handleInvModClose = () => {
    setPosPayId(null);
    setSelectedBill(null);
    setInvModVisible(false);
  };

  const handleChangePage = (e, selectedPage) => {
    onPaymentsApiCall(selectedPage);
  };

  const handleClosePayMod = (typ) => {
    if (typ === "apiSuccess") {
      onPaymentsApiCall(page);
    }
    setPayModalVisible(false);
    setModalData(null);

    // setPayValues(initialValues);
    // setTotalBalanceDue(0);
    // setPayErr({});
  };

  const onCloseRetMod = () => {
    setCancelModVsble(false);
    setReturnModVsble(false);
    setSelectedBill(null);
  };

  const handleChange = (name, value) => {
    const reqObj = { ...returnValue, [name]: value };
    if (
      name === "personInCharge" ||
      name === "refundMethod" ||
      name === "returnReason"
    ) {
      const reqValue =
        typeof value === "object" ? (value?.value ?? "")?.toString() : value;
      reqObj[errMap?.[name]] = reqValue?.length > 0 ? "" : reqTxt;
    }

    if (name === "isInvoiceSelected" && value) {
      const tabList = returnValue?.selectedInvoiceNumber?.includes("INVC")
        ? getTreatmentRecordBasedType(selectedBill?.paymentDetails)
        : returnValue?.selectedInvoiceNumber?.includes("INVP")
          ? getPharmacyRecordBasedType(selectedBill?.paymentDetails)
          : returnValue?.selectedInvoiceNumber?.includes("INVS")
            ? getPetShopRecordBasedType(selectedBill?.paymentDetails)
            : [];
      const reqReturnList = getCombinedReturnedQuantity(
        selectedBill?.paymentReturns ?? [],
      );
      const reqList = tabList
        ?.filter((li) => {
          const isProcedureSubItem =
            (li?.procedureId ?? "")?.toString()?.length > 0 &&
            !li?.mainProcedure &&
            li?.linked !== "N";
          if (!isProcedureSubItem) return li;
        })
        ?.map((item) => {
          const returnedItem = reqReturnList?.find((ret) => {
            const isServiceMatch =
              item?.serviceId != null &&
              ret?.serviceId != null &&
              item?.serviceId === ret?.serviceId;

            const isProductMatch =
              item?.stockId != null &&
              ret?.stockId != null &&
              item?.stockId === ret?.stockId &&
              item?.batchId === ret?.batchId;

            return (
              (isServiceMatch || isProductMatch) &&
              Number(ret?.returnQuantity ?? 0) > 0
            );
          });

          const returnedQty = Number(returnedItem?.returnQuantity ?? 0);
          const originalQty = Number(item?.quantity ?? 0);

          return {
            ...item,
            returnableQuantity: returnedQty > 0 ? 0 : originalQty - returnedQty,
            returnQuantity: 0,
          };
        })
        // remove fully returned items
        ?.filter((item) => Number(item?.returnableQuantity ?? 0) > 0);
      reqObj.list = reqList;
    }
    setReturnValue(reqObj);
  };

  const onReasonChange = (name, value) => {
    const reqValue =
      typeof value === "object" ? (value?.value ?? "")?.toString() : value;
    const reqObj = {
      ...cancelValues,
      [name]: value,
      [errMap?.[name]]: reqValue?.length > 0 ? "" : reqTxt,
    };
    if (reqObj?.cancelReason?.value?.toLowerCase() !== "others") {
      reqObj.remarkErr = "";
    }
    setCancelValues(reqObj);
  };

  const handleChangeRetQty = (value, ind) => {
    const reqList = returnValue?.list?.map((li, i) => {
      if (i === ind) {
        const reqObj = {
          ...li,
          returnQuantity: value,
          returnQuantityErr:
            Number(li?.returnableQuantity) < Number(value)
              ? "Maximum limit reached"
              : "",
        };
        return reqObj;
      }
      return li;
    });
    const reqValue = { ...returnValue, list: reqList };
    if (listNotValid) {
      if (reqList?.some((li) => Number(li?.returnQuantity) > 0)) {
        setListNotValid(false);
      }
    }
    setReturnValue(reqValue);
  };

  const submitReturn = (status = "") => {
    const returnList = returnValue?.list?.filter(
      (li) => Number(li?.returnQuantity) > 0,
    );
    if (returnList?.length === 0 || !returnList) return setListNotValid(true);
    if (
      !returnValue?.refundMethod?.value ||
      !returnValue?.personInCharge?.value ||
      !returnValue?.returnReason?.value
    ) {
      return setReturnValue({
        ...returnValue,
        inChargeErr: returnValue?.personInCharge?.value ? "" : reqTxt,
        refundMethodErr: returnValue?.refundMethod?.value ? "" : reqTxt,
        reasonErr: returnValue?.returnReason?.value ? "" : reqTxt,
      });
    }
    const paymentDetails = returnList?.map((li) => {
      const unitPrice = isNaN(Number(Number(li?.total) / Number(li?.quantity)))
        ? 0
        : Number(Number(li?.total) / Number(li?.quantity));
      const unitTax = isNaN(Number(Number(li?.tax) / Number(li?.quantity)))
        ? 0
        : Number(Number(li?.tax) / Number(li?.quantity));
      const reqbj = {
        unitPrice,
        unitTax,
        quantity: li?.quantity ?? 0,
        tax: Number(Number(unitTax ?? 0) * Number(li?.returnQuantity ?? 0)),
        price: li?.price,
        total: Number(Number(unitPrice ?? 0) * Number(li?.returnQuantity ?? 0)),
        returnQuantity: Number(li?.returnQuantity ?? 0),
        name: li?.name,
        paymentDetailId: li?.paymentDetailId ?? null,
        stockId: li?.stockId ?? null,
        batchId: li?.batchId ?? null,
      };
      if (li?.uomName) reqbj.uomName = li?.uomName;
      if (li?.uomId) reqbj.uomId = li?.uomId;
      if (li?.serviceId) reqbj.serviceId = li?.serviceId;
      if (li?.stockId) reqbj.stockId = li?.stockId;
      if (li?.batchId) reqbj.batchId = li?.batchId;
      if (li?.paymentDetailId) reqbj.paymentDetailId = li?.paymentDetailId;
      return reqbj;
    });
    const sumPaymentDetailsBy = (key) =>
      paymentDetails?.reduce((acc, obj) => acc + Number(obj?.[key] ?? 0), 0);

    const amountPaid = Number(
      selectedBill?.tab === "petShop"
        ? (selectedBill?.petShopAmtPaid ?? 0)
        : selectedBill?.tab === "pharmacy"
          ? (selectedBill?.pharmacyAmtPaid ?? 0)
          : (selectedBill?.amtPaid ?? 0),
    );
    const paymentStatus =
      (selectedBill?.tab === "petShop"
        ? selectedBill?.petShopStatus
        : selectedBill?.tab === "pharmacy"
          ? selectedBill?.pharmacyStatus
          : selectedBill?.status) ?? "unpaid";
    const balanceDueAmount = Number(
      selectedBill?.tab === "petShop"
        ? (selectedBill?.petShopBalanceDue ?? 0)
        : selectedBill?.tab === "pharmacy"
          ? (selectedBill?.pharmacyBalanceDue ?? 0)
          : (selectedBill?.balanceDue ?? 0),
    );
    const totalAmount = Number(
      selectedBill?.tab === "petShop"
        ? (selectedBill?.petShopTotalAmt ?? 0)
        : selectedBill?.tab === "pharmacy"
          ? (selectedBill?.pharmacyTotalAmt ?? 0)
          : (selectedBill?.totalAmt ?? 0),
    );
    const remainingItemsValue = (returnValue?.list ?? [])?.reduce((acc, li) => {
      const remainingQty = Math.max(
        0,
        Number(li?.returnableQuantity ?? 0) - Number(li?.returnQuantity ?? 0),
      );
      const unitPrice = isNaN(Number(Number(li?.total) / Number(li?.quantity)))
        ? 0
        : Number(Number(li?.total) / Number(li?.quantity));
      return acc + Number(unitPrice) * remainingQty;
    }, 0);

    const refundAmount = Math.max(
      0,
      amountPaid - Number(remainingItemsValue ?? 0),
    );
    const isFullReturn = returnValue?.list?.every(
      (li) =>
        Number(li?.returnableQuantity ?? 0) === Number(li?.returnQuantity ?? 0),
    );

    const data = {
      type: "sales",
      paymentMode: amountPaid > 0 ? returnValue?.refundMethod?.value : null,
      personInCharge: returnValue?.personInCharge?.value ?? null,
      returnReason: returnValue?.returnReason?.value,
      paymentDetails,
      creditSave: status,
      remarks: returnValue?.remarks ?? "",
      invoiceNumbers: returnValue?.selectedInvoiceNumber,
      refundAmount: -Number(refundAmount),
      totalAmt: -Number(sumPaymentDetailsBy("total") ?? 0),
      totalTax: -Number(sumPaymentDetailsBy("tax") ?? 0),
      returned: status === "credit" ? isFullReturn : false,
    };
    // if (returnValue?.isCancel) {
    //   if (
    //     (selectedBill?.tab ?? returnValue?.tab)?.toLowerCase() === "treatment"
    //   )
    //     data.status = "cancelled";
    //   if ((selectedBill?.tab ?? returnValue?.tab)?.toLowerCase() === "pharmacy")
    //     data.pharmacyStatus = "cancelled";
    //   if ((selectedBill?.tab ?? returnValue?.tab)?.toLowerCase() === "petshop")
    //     data.petShopStatus = "cancelled";
    // }
    dispatch(
      createReturnOnBillingItems({ data, id: selectedBill?.paymentId }),
      // updateReturnOnBillingItems({ data, id: selectedBill?.paymentId }),
    ).then((res) => {
      if (res?.payload) {
        if (status === "credit" && paymentStatus?.toLowerCase() !== "paid") {
          const payDetails = getPaymentStatusAndRefund({
            totalAmount: Math.round(totalAmount),
            amountPaid: Math.round(amountPaid),
            returnableAmount: Math.round(
              Number(sumPaymentDetailsBy("total") ?? 0),
            ),
          });
          const dataToUpdate = {
            [selectedBill?.tab === "petShop"
              ? "petShopStatus"
              : selectedBill?.tab === "pharmacy"
                ? "pharmacyStatus"
                : "status"]: payDetails?.status,
            [selectedBill?.tab === "petShop"
              ? "petShopBalanceDue"
              : selectedBill?.tab === "pharmacy"
                ? "pharmacyBalanceDue"
                : "balanceDue"]: payDetails?.balanceDueAfterReturn,
          };
          if (selectedBill?.paymentId) {
            dispatch(
              updateBalanceDueAndStatusByPaymentId({
                paymentId: selectedBill?.paymentId,
                data: dataToUpdate,
              }),
            ).then((updateRes) => {
              if (updateRes?.payload) {
                onPaymentsApiCall(page);
                onCloseRetMod();
              }
            });
          } else {
            onPaymentsApiCall(page);
            onCloseRetMod();
          }
        } else {
          onPaymentsApiCall(page);
          onCloseRetMod();
        }
      }
    });
  };

  const onSearchChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = {
      ...searchValues,
      [name?.trim()?.replace(/,$/, "")]: value, // remove spaces & trailing commas
    };
    setSearchValues(reqObj);
  };

  const onFilterChange = (name, value) => {
    const reqObj = { ...filterValues, [name]: value };
    setFilterValues(reqObj);
  };

  const onApplyFilter = () => {
    onPaymentsApiCall(1);
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const onFilterReset = () => {
    const reqObj = { ...initFilter, visible: true };
    setFilterValues(reqObj);
  };

  const onCloseFilter = () => {
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
    // if (filterValues?.selectedList?.length === 0) return;
    // onPaymentsApiCall(1);
  };

  const onSelectFilter = (name) => {
    const reqObj = { ...filterValues };
    let reqList = filterValues?.selectedList;
    if (reqList?.includes(name)) {
      reqList = reqList?.filter((item) => item !== name);
    } else {
      reqList.push(name);
    }
    reqObj.selectedList = reqList;
    setFilterValues(reqObj);
  };

  const onFilterAdd = (value) => {
    const reqObj = { ...filterValues, added: value };
    setFilterValues(reqObj);
  };

  const onFilterValuesChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = {
      ...filterValues,
      values: {
        ...filterValues?.values,
        [name?.trim()?.replace(/,$/, "")]: value,
      },
    };
    setFilterValues(reqObj);
  };

  const onReset = () => {
    flushSync(() => {
      setSearchValues(initSearch);
    });
    flushSync(() => {
      setFilterValues({ ...initFilter, selectedList: [], values: {} });
    });
    onPaymentsApiCall(1, true);
  };

  const getPaymentMethodList = () => {
    return (
      paymentMethod?.list?.map((li) => ({
        name: li?.name,
        value: li?.name,
      })) ?? []
    );
  };

  const getClinicVetList = () => {
    return (
      clinicVets
        ?.filter((vl) => {
          if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
            return vl;
          }
        })
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.name, id: vet?.doctorId };
        }) ?? []
    );
  };

  const getBatch = (stkId = null, batchId = null) => {
    if (!stkId || !batchId) return null;
    const reqStock = stocks?.data?.find((stc) => stc?.stockId === stkId);
    return (
      reqStock?.stockBatch?.find((bat) => bat?.batchId === batchId) ?? null
    );
  };

  const getInvoiceNumbers = () => {
    const reqList =
      selectedBill?.type?.toLowerCase() === "pharmacy"
        ? [selectedBill?.invoiceNumbers ?? ""]
        : selectedBill?.type?.toLowerCase() === "pet shop"
          ? [selectedBill?.petShopInvoiceNumber ?? ""]
          : [
              selectedBill?.invoiceNumbers ?? "",
              selectedBill?.treatmentInvoiceNumber ?? "",
              selectedBill?.petShopInvoiceNumber ?? "",
            ]?.filter(Boolean);
    return reqList?.map((li) => {
      const reqList = li?.includes("INVC")
        ? getTreatmentRecordBasedType(selectedBill?.paymentDetails)
        : li?.includes("INVP")
          ? getPharmacyRecordBasedType(selectedBill?.paymentDetails)
          : li?.includes("INVS")
            ? getPetShopRecordBasedType(selectedBill?.paymentDetails)
            : [];
      const reqAmtData = roundWithSignedDiff(
        getTaxAndSubTotalAndTotal(reqList)?.subTotal,
      );
      return {
        name: `${li}, ₹${reqAmtData?.rounded}, ${moment(new Date(selectedBill?.createdDate)).format("DD MMM YYYY")}`,
        value: li,
      };
    });
  };

  const onTabChange = (tab) => {
    setSelectedPaymentTab(tab);
    setSearchValues(initSearch);
    setFilterValues({ ...initFilter, selectedList: [], values: {} });
    onPaymentsApiCall(1, true, null, null, tab);
  };

  const getFieldName = (name, type) => {
    if (name === "Total Due") {
      if (type === "start") return "Min Total Due";
      return "Max Total Due";
    }
    if (name === "Balance Due") {
      if (type === "start") return "Min Balance Due";
      return "Max Balance Due";
    }
    if (name === "Transaction Date") {
      if (type === "start") return "Start Date";
      return "End Date";
    }
  };

  const reqTableList = () => {
    // const getPayStatus = (totalAmt, totalAmtPaid) =>
    //   Number(totalAmt ?? 0) === Number(totalAmtPaid ?? 0)
    //     ? "Paid"
    //     : Number(totalAmtPaid ?? 0) > 0
    //       ? "Partially Paid"
    //       : "Unpaid";

    const isMainCheckedForPay = (pay) =>
      pay?.appointmentId
        ? ["Y"].includes(pay?.checkOut || pay?.checkout)
        : ["P", "Y"].includes(pay?.checkOut);

    const shouldPushRow = (checkoutValue) => {
      if (selectedPaymentTab === "Finalized") {
        return checkoutValue === "Y" || checkoutValue === "P";
      }
      if (selectedPaymentTab === "Pending") {
        return checkoutValue !== "Y" && checkoutValue !== "P";
      }
      return false;
    };

    const getReturnFlags = (tabList, paymentReturns) => {
      const reqReturnList = getCombinedReturnedQuantity(paymentReturns ?? []);
      const processedItems = (tabList ?? [])
        ?.filter((li) => {
          const isProcedureSubItem =
            (li?.procedureId ?? "")?.toString()?.length > 0 &&
            !li?.mainProcedure &&
            li?.linked !== "N";
          if (!isProcedureSubItem) return li;
        })
        ?.map((item) => {
          const returnedItem = reqReturnList?.find((ret) => {
            const isServiceMatch =
              item?.serviceId != null &&
              ret?.serviceId != null &&
              item?.serviceId === ret?.serviceId;

            const isProductMatch =
              item?.stockId != null &&
              ret?.stockId != null &&
              item?.stockId === ret?.stockId &&
              item?.batchId === ret?.batchId;

            return (
              (isServiceMatch || isProductMatch) &&
              Number(ret?.returnQuantity ?? 0) > 0
            );
          });

          const returnedQty = Number(returnedItem?.returnQuantity ?? 0);
          const originalQty = Number(item?.quantity ?? 0);

          return {
            returnableQuantity: returnedQty > 0 ? 0 : originalQty - returnedQty,
          };
        });

      const returnableItems = processedItems?.filter(
        (item) => Number(item?.returnableQuantity ?? 0) > 0,
      );

      return {
        returnable: (returnableItems?.length ?? 0) > 0,
        allReturned:
          (processedItems?.length ?? 0) > 0 &&
          (returnableItems?.length ?? 0) === 0,
      };
    };

    const list = [];
    (paymentsByFilter?.data ?? [])?.forEach((pay) => {
      if (pay?.type !== "Clinic") {
        const totalAmt =
          (pay?.totalAmt ?? 0) +
          (pay?.pharmacyTotalAmt ?? 0) +
          (pay?.petShopTotalAmt ?? 0);
        const balDue =
          (pay?.balanceDue ?? 0) +
          (pay?.pharmacyBalanceDue ?? 0) +
          (pay?.petShopBalanceDue ?? 0);
        const totalAmtPaid =
          (pay?.amtPaid ?? 0) +
          (pay?.pharmacyAmtPaid ?? 0) +
          (pay?.petShopAmtPaid ?? 0);
        const isMainChecked = isMainCheckedForPay(pay);
        const checked =
          isMainChecked ||
          pay?.pharmacyCheckout === "Y" ||
          pay?.petShopCheckout === "Y";
        const notFullyPaid = pay?.appointmentId
          ? notPaidList.includes((pay?.status ?? "")?.toLowerCase()) ||
            notPaidList.includes((pay?.pharmacyStatus ?? "")?.toLowerCase()) ||
            !pay?.pharmacyStatus ||
            notPaidList.includes((pay?.petShopStatus ?? "")?.toLowerCase()) ||
            !pay?.petShopStatus
          : notPaidList.includes((pay?.status ?? "")?.toLowerCase());
        const reqStatus =
          pay?.type === "Pharmacy" ? pay?.pharmacyStatus : pay?.petShopStatus;
        const tabListForReturn =
          pay?.type === "Pharmacy"
            ? getPharmacyRecordBasedType(pay?.paymentDetails, isBillCombined)
            : getPetShopRecordBasedType(pay?.paymentDetails, isBillCombined);
        const { allReturned, returnable } = getReturnFlags(
          tabListForReturn,
          pay?.paymentReturns,
        );
        const allStatusReturned =
          pay?.paymentReturns?.length > 0
            ? pay?.paymentReturns?.every(
                (pr) => (pr?.creditSave ?? "")?.toLowerCase() === "credit",
              )
            : false;
        if (
          selectedPaymentTab === "Pending" &&
          (pay?.type === "Pharmacy"
            ? pay?.pharmacyCheckout === "Y"
            : pay?.petShopCheckout === "Y")
        ) {
          return;
        }
        list.push({
          ...pay,
          isNotCancelled: (reqStatus ?? "")?.toLowerCase() !== "cancelled",
          returned: pay?.returned ?? false,
          allReturned,
          returnable,
          allStatusReturned,
          payStatus: reqStatus,
          notFullyPaid,
          checked,
          isMainChecked,
          totalAmt,
          balDue,
          totalAmtPaid,
          tab: billingTabEnum?.[pay?.type],
        });
        return;
      }

      const treatTabList = getTreatmentRecordBasedType(
        pay?.paymentDetails,
        isBillCombined,
      );
      const pharTabList = getPharmacyRecordBasedType(
        pay?.paymentDetails,
        isBillCombined,
      );
      const petShopTabList = getPetShopRecordBasedType(
        pay?.paymentDetails,
        isBillCombined,
      );
      const isMainChecked = isMainCheckedForPay(pay);

      const clinicTabs = [
        {
          tab: "treatment",
          returned: pay?.returned ?? false,
          payStatus: pay?.status,
          enabled: Array.isArray(treatTabList),
          details: treatTabList,
          totalAmt: pay?.totalAmt ?? 0,
          balDue: pay?.balanceDue ?? 0,
          totalAmtPaid: pay?.amtPaid ?? 0,
          checked: isMainChecked,
          notFullyPaid: notPaidList.includes(
            (pay?.status ?? "")?.toLowerCase(),
          ),
          checkoutValue: pay?.checkOut,
          nullInvoiceFields: {
            invoiceNumbers: null,
            petShopInvoiceNumber: null,
          },
          genBillShow: !isMainChecked,
          isNotCancelled: pay?.status !== "cancelled",
          enableCancel: pay?.status !== "paid",
          isCancelled: pay?.status === "cancelled",
          reqInvoiceNo: pay?.treatmentInvoiceNumber,
        },
        {
          tab: "pharmacy",
          returned: pay?.returned ?? false,
          payStatus: pay?.pharmacyStatus,
          enabled:
            Array.isArray(pharTabList) &&
            pharTabList?.length > 0 &&
            !isBillCombined,
          details: pharTabList,
          totalAmt: pay?.pharmacyTotalAmt ?? 0,
          balDue: pay?.pharmacyBalanceDue ?? 0,
          totalAmtPaid: pay?.pharmacyAmtPaid ?? 0,
          checked: pay?.pharmacyCheckout === "Y",
          notFullyPaid: pay?.appointmentId
            ? notPaidList.includes((pay?.status ?? "")?.toLowerCase()) ||
              notPaidList.includes(
                (pay?.pharmacyStatus ?? "")?.toLowerCase(),
              ) ||
              !pay?.pharmacyStatus
            : notPaidList.includes((pay?.status ?? "")?.toLowerCase()),
          checkoutValue: pay?.pharmacyCheckout,
          nullInvoiceFields: {
            treatmentInvoiceNumber: null,
            petShopInvoiceNumber: null,
          },
          genBillShow:
            pay?.pharmacyCheckout !== "Y" && (pharTabList?.length ?? 0) > 0,
          isNotCancelled: pay?.pharmacyStatus !== "cancelled",
          enableCancel: pay?.pharmacyStatus !== "paid",
          isCancelled: pay?.pharmacyStatus === "cancelled",
          reqInvoiceNo: pay?.invoiceNumbers,
        },
        {
          tab: "petShop",
          returned: pay?.returned ?? false,
          payStatus: pay?.petShopStatus,
          enabled:
            Array.isArray(petShopTabList) &&
            petShopTabList?.length > 0 &&
            !isBillCombined,
          details: petShopTabList,
          totalAmt: pay?.petShopTotalAmt ?? 0,
          balDue: pay?.petShopBalanceDue ?? 0,
          totalAmtPaid: pay?.petShopAmtPaid ?? 0,
          checked: pay?.petShopCheckout === "Y",
          notFullyPaid: pay?.appointmentId
            ? notPaidList.includes((pay?.status ?? "")?.toLowerCase()) ||
              notPaidList.includes((pay?.petShopStatus ?? "")?.toLowerCase()) ||
              !pay?.petShopStatus
            : notPaidList.includes((pay?.status ?? "")?.toLowerCase()),
          checkoutValue: pay?.petShopCheckout,
          nullInvoiceFields: {
            invoiceNumbers: null,
            treatmentInvoiceNumber: null,
          },
          genBillShow:
            pay?.petShopCheckout !== "Y" && (petShopTabList?.length ?? 0) > 0,
          isNotCancelled: pay?.petShopStatus !== "cancelled",
          enableCancel: pay?.petShopStatus !== "paid",
          isCancelled: pay?.petShopStatus === "cancelled",
          reqInvoiceNo: pay?.petShopInvoiceNumber,
        },
      ];

      clinicTabs?.forEach((t) => {
        if (!t.enabled) return;
        if (!shouldPushRow(t?.checkoutValue)) return;

        const { allReturned, returnable } = getReturnFlags(
          t.details,
          pay?.paymentReturns,
        );
        const allStatusReturned =
          pay?.paymentReturns?.length > 0
            ? pay?.paymentReturns?.every(
                (pr) => (pr?.creditSave ?? "")?.toLowerCase() === "credit",
              )
            : false;

        list.push({
          ...pay,
          returned: t.returned,
          allReturned,
          returnable,
          allStatusReturned,
          payStatus: t.payStatus,
          notFullyPaid: t.notFullyPaid,
          checked: t.checked,
          isMainChecked,
          totalAmt: t.totalAmt,
          balDue: t.balDue,
          totalAmtPaid: t.totalAmtPaid,
          paymentDetails: t.details,
          ...t.nullInvoiceFields,
          tab: t.tab,
          genBillShow: t.genBillShow,
          isNotCancelled: t.isNotCancelled,
          reqInvoiceNo: t?.reqInvoiceNo,
          enableCancel: t?.enableCancel,
          isCancelled: t?.isCancelled,
        });
      });
    });
    const reqList = list?.filter((li) => {
      const srcMatch =
        searchValues?.source?.length > 0
          ? searchValues?.source?.some(
              (st) => st?.value?.toLowerCase() === "all",
            )
            ? true
            : searchValues?.source?.some(
                (st) => st?.apiValue === tabEnum?.[li?.tab],
              )
          : true;
      const statMatc =
        searchValues?.status?.length > 0
          ? searchValues?.status?.some(
              (st) => st?.value?.toLowerCase() === "all",
            )
            ? true
            : searchValues?.status?.some((st) => st?.value === li?.payStatus)
          : true;
      return selectedPaymentTab !== "Finalized" || (statMatc && srcMatch);
    });
    return reqList;
  };

  const onDownloadReport = () => {
    if (selectedPaymentTab === "Finalized") {
      let closedUrl = `${baseURL}/payments/search/export-excel?clinicId=${clinicDet?.id}&checkOut=Y`;
      // let closedUrl = `${baseURL}/clinic/payment/export-today-checkout-excel?clinicId=${clinicDet?.id}`;
      if (searchValues?.petName?.length > 0) {
        closedUrl += `&petName=${searchValues?.petName}`;
      }
      if (searchValues?.userName?.length > 0) {
        closedUrl += `&username=${searchValues?.userName}`;
      }
      if (searchValues?.source?.length > 0) {
        closedUrl += `&type=${
          (searchValues?.source ?? [])?.some(
            (li) => li?.value?.toLowerCase() === "all",
          )
            ? ["Clinic", "Pharmacy", "Pet Shop"]
            : (searchValues?.source ?? [])?.map((li) => li?.value)
        }`;
      }
      if (searchValues?.status?.length > 0) {
        closedUrl += `&status=${
          (searchValues?.status ?? [])?.some((li) => li?.value === "all")
            ? ["paid", "unpaid", "ppaid", "partiallypaid", "cancelled"]
            : (searchValues?.status ?? [])?.map(
                (li) => paymentKeyword?.[li?.value],
              )
        }`;
      }

      if (filterValues?.selectedList?.includes("Transaction Date")) {
        closedUrl += `&startDate=${moment(
          new Date(
            new Date(filterValues?.values?.["Start Date"] ?? new Date()),
          ),
        ).format("YYYY-MM-DD")}`;
        if (filterValues?.values?.["End Date"]) {
          closedUrl += `&endDate=${moment(
            new Date(
              new Date(filterValues?.values?.["End Date"] ?? new Date()),
            ),
          ).format("YYYY-MM-DD")}`;
        }
      }
      if (
        filterValues?.selectedList?.includes("Invoice Number") &&
        filterValues?.values?.["Invoice Number"]?.length > 0
      ) {
        closedUrl += `&invoiceNumber=${filterValues?.values?.["Invoice Number"]}`;
      }
      if (filterValues?.selectedList?.includes("Total Due")) {
        closedUrl += `&totalDueMin=${Number(filterValues?.values?.["Min Total Due"] ?? 0)}&totalDueMax=${Number(filterValues?.values?.["Max Total Due"] ?? 0)}`;
      }
      if (filterValues?.selectedList?.includes("Balance Due")) {
        closedUrl += `&balanceDueMin=${Number(
          filterValues?.values?.["Min Balance Due"] ?? 0,
        )}&balanceDueMax=${Number(
          filterValues?.values?.["Max Balance Due"] ?? 0,
        )}`;
      }
      if (
        filterValues?.selectedList?.includes("Invoice Type") &&
        filterValues?.values?.["Invoice Type"]?.length > 0
      ) {
        closedUrl += `&invoiceType=${filterValues?.values?.[
          "Invoice Type"
        ]?.map((li) => li?.value)}`;
      }
      if (
        filterValues?.selectedList?.includes("Payment Mode") &&
        filterValues?.values?.["Payment Mode"]?.length > 0
      ) {
        closedUrl += `&paymentMode=${filterValues?.values?.[
          "Payment Mode"
        ]?.map((li) => li?.value)}`;
      }
      if (
        filterValues?.selectedList?.includes("Person In Charge") &&
        filterValues?.values?.["Person In Charge"]
      ) {
        closedUrl += `&personInCharge=${filterValues?.values?.["Person In Charge"]}`;
      }
      // const todayDate = moment(new Date()).format("YYYY-MM-DD");
      // const thirtyDaysAgo = moment(
      //   new Date(new Date().setDate(new Date().getDate() - 30)),
      // ).format("YYYY-MM-DD");
      // const url = `${baseURL}/clinic/payment/export-today-checkout-excel?startDate=${thirtyDaysAgo}&endDate=${todayDate}&clinicId=${clinicDet?.id}`;

      // `${baseURL}/clinic/payment/collection/download-daily?clinicId=${clinicDet?.id}&date=${reqDate}`;
      // /clinic/payment/export-today-checkout-excel?startDate=2026-04-01&endDate=2026-04-07&clinicId=2
      // /clinic/payment/export-today-checkout-excel?date=2026-04-01&clinicId=2
      window.open(closedUrl, "_blank");
    }
    if (selectedPaymentTab === "Pending") {
      let openUrl = `${baseURL}/payments/search/export-excel?clinicId=${clinicDet?.id}&checkOut=N`;
      if (searchValues?.source?.length > 0) {
        openUrl += `&type=${
          (searchValues?.source ?? [])?.some(
            (li) => li?.value?.toLowerCase() === "all",
          )
            ? ["Clinic", "Pharmacy", "Pet Shop"]
            : (searchValues?.source ?? [])?.map((li) => li?.value)
        }`;
      }
      if (searchValues?.petName?.length > 0) {
        openUrl += `&petName=${searchValues?.petName}`;
      }
      if (searchValues?.userName?.length > 0) {
        openUrl += `&username=${searchValues?.userName}`;
      }
      if (searchValues?.vetName?.length > 0) {
        openUrl += `&vetName=${searchValues?.userName}`;
      }

      if (filterValues?.selectedList?.includes("Transaction Date")) {
        openUrl += `&startDate=${moment(
          new Date(
            new Date(filterValues?.values?.["Start Date"] ?? new Date()),
          ),
        ).format("YYYY-MM-DD")}`;
        if (filterValues?.values?.["End Date"]) {
          openUrl += `&endDate=${moment(
            new Date(
              new Date(filterValues?.values?.["End Date"] ?? new Date()),
            ),
          ).format("YYYY-MM-DD")}`;
        }
      }
      if (
        filterValues?.selectedList?.includes("Invoice Number") &&
        filterValues?.values?.["Invoice Number"]?.length > 0
      ) {
        openUrl += `&invoiceNumber=${filterValues?.values?.["Invoice Number"]}`;
      }
      if (filterValues?.selectedList?.includes("Total Due")) {
        openUrl += `&totalDueMin=${Number(filterValues?.values?.["Min Total Due"] ?? 0)}&totalDueMax=${Number(filterValues?.values?.["Max Total Due"] ?? 0)}`;
      }
      if (filterValues?.selectedList?.includes("Balance Due")) {
        openUrl += `&balanceDueMin=${Number(
          filterValues?.values?.["Min Balance Due"] ?? 0,
        )}&balanceDueMax=${Number(
          filterValues?.values?.["Max Balance Due"] ?? 0,
        )}`;
      }
      if (
        filterValues?.selectedList?.includes("Invoice Type") &&
        filterValues?.values?.["Invoice Type"]?.length > 0
      ) {
        openUrl += `&invoiceType=${filterValues?.values?.["Invoice Type"]?.map(
          (li) => li?.value,
        )}`;
      }
      if (
        filterValues?.selectedList?.includes("Payment Mode") &&
        filterValues?.values?.["Payment Mode"]?.length > 0
      ) {
        openUrl += `&paymentMode=${filterValues?.values?.["Payment Mode"]?.map(
          (li) => li?.value,
        )}`;
      }
      window.open(openUrl, "_blank");
    }
  };

  const onCancelPayment = (itm) => {
    setCancelValues({
      personInCharge: null,
      cancelReason: null,
      cancelRemarks: "",
      refundMethod: { name: "Advance Adjustment", value: "advanceAdjustment" },
    });
    setSelectedBill(itm);
    setCancelModVsble(true);
  };

  const onCloseCancelMod = () => {
    setCancelModVsble(false);
    setSelectedBill(null);
  };

  const onConfirmCancelMod = () => {
    if (
      !cancelValues?.personInCharge?.value ||
      !cancelValues?.refundMethod?.value ||
      !cancelValues?.cancelReason?.value ||
      (cancelValues?.cancelReason?.value?.toLowerCase() === "others" &&
        (cancelValues?.cancelRemarks?.length === 0 ||
          !cancelValues?.cancelRemarks))
    ) {
      setCancelValues({
        ...cancelValues,
        inChargeErr: cancelValues?.personInCharge?.value ? "" : reqTxt,
        refundMethodErr: cancelValues?.refundMethod?.value ? "" : reqTxt,
        reasonErr: cancelValues?.cancelReason?.value ? "" : reqTxt,
        remarkErr:
          cancelValues?.cancelRemarks?.length > 0
            ? ""
            : cancelValues?.cancelReason?.value?.toLowerCase() === "others"
              ? reqTxt
              : "",
      });
    }
    const totalObj = getTaxAndSubTotalAndTotal(selectedBill?.paymentDetails);
    const data = {
      type: selectedBill?.tab,
      invoiceNo: selectedBill?.reqInvoiceNo ?? "",
      billedById: selectedBill?.billedById ?? null,
      billedByName: selectedBill?.billedByName ?? null,

      cancelReason: cancelValues?.cancelReason?.value,
      cancelRemarks: cancelValues?.cancelRemarks ?? "",
      personInCharge: cancelValues?.personInCharge?.value,
      refundMethod:
        Math.abs(selectedBill?.totalAmtPaid ?? 0) > 0
          ? (cancelValues?.refundMethod?.value ?? null)
          : null,
      refundTax: Number(totalObj?.tax ?? 0),
      refundTotal:
        selectedBill?.payStatus === "unpaid" || !selectedBill?.payStatus
          ? null
          : Math.abs(selectedBill?.totalAmtPaid ?? 0) > 0
            ? -Number(selectedBill?.totalAmtPaid)
            : 0,
    };
    dispatch(
      cancelPaymentById({
        id: selectedBill?.paymentId,
        data,
      }),
    ).then((res) => {
      if (res?.payload) {
        onPaymentsApiCall(page);
        onCloseCancelMod();
      }
    });
  };

  const onCloseGenBillMod = () => {
    setGenBillModVsble(false);
    setSelectedBill(null);
  };

  const totalPage = Math.ceil(paymentsByFilter?.totalRecords / itemsPerLoad);

  return (
    <>
      <div className="flex-row light-blue-back3 pv5">
        <Typography
          className={`ml20 newTab ph10 cursor ${selectedPaymentTab === "Pending" ? "newTabSelected blue-color" : ""}`}
          onClick={() => onTabChange("Pending")}
        >
          Open {/* Pending */}
        </Typography>
        <Typography
          className={`ml20 newTab ph10 cursor ${selectedPaymentTab === "Finalized" ? "newTabSelected blue-color" : ""}`}
          onClick={() => onTabChange("Finalized")}
        >
          Closed {/* Finalized */}
        </Typography>
        <Typography
          className={`ml20 newTab ph10 cursor ${selectedPaymentTab === "Collections" ? "newTabSelected blue-color" : ""}`}
          onClick={() => onTabChange("Collections")}
        >
          Collections
        </Typography>
      </div>
      {selectedPaymentTab === "Collections" ? (
        <CollectionsTable
          paymentTableType={paymentTableType}
          setPaymentTableType={setPaymentTableType}
        />
      ) : null}
      {selectedPaymentTab === "Finalized" ||
      selectedPaymentTab === "Pending" ? (
        <>
          <div className="flex-row mv10">
            <div className="top-row-cen-con w100Per">
              <div className="w15Per">
                <CustomTextField
                  placeholder="Pet Name"
                  fullWidth
                  name="petName"
                  handleChange={onSearchChange}
                  value={searchValues?.petName}
                  backgroundColor={AppColors.lightBlue2}
                  label="Pet Name"
                />
              </div>
              <div className="w15Per ml15">
                <CustomTextField
                  placeholder="User Name"
                  fullWidth
                  name="userName"
                  handleChange={onSearchChange}
                  value={searchValues?.userName}
                  backgroundColor={AppColors.lightBlue2}
                  label="User Name"
                />
              </div>
              {selectedPaymentTab === "Pending" ? (
                <div className="w15Per ml15">
                  <CustomTextField
                    placeholder="Vet Name"
                    fullWidth
                    name="vetName"
                    handleChange={onSearchChange}
                    value={searchValues?.vetName}
                    backgroundColor={AppColors.lightBlue2}
                    label="Vet Name"
                  />
                </div>
              ) : null}
              <div className="w15Per ml15">
                <CustomSelect
                  list={paymentSourceTypes}
                  value={searchValues?.source ?? []}
                  name="source"
                  handleChange={onSearchChange}
                  label="Source"
                  multiSelectSearchCheck
                  backgroundColor={AppColors.lightBlue2}
                />
              </div>
              {selectedPaymentTab === "Finalized" ? (
                <div className="w15Per ml15">
                  <CustomSelect
                    list={paymentStatusList}
                    value={searchValues?.status ?? []}
                    name="status"
                    handleChange={onSearchChange}
                    label="Status"
                    multiSelectSearchCheck
                    backgroundColor={AppColors.lightBlue2}
                  />
                </div>
              ) : null}
              {/* {selectedPaymentTab === "Finalized" ? ( */}
              <div
                className="flex-row-ali-cen ml15 filter cursor"
                onClick={() => onFilterChange("visible", true)}
              >
                <TuneIcon sx={{ color: AppColors.appPrimary }} />
                <Typography className="font-medium fs12 blue-color ml10">
                  {filterValues?.selectedList?.length > 0
                    ? `${filterValues?.selectedList?.length} `
                    : ""}
                  Filter
                </Typography>
              </div>
              {/* ) : null} */}
              <div className="ml15">
                <CustomButton text="Reset" onClick={onReset} smallBtn redBtn />
              </div>
              {/* {selectedPaymentTab === "Finalized" ? ( */}
              <div className="ml15">
                <CustomButton text="⬇" onClick={onDownloadReport} smallBtn />
              </div>
              {/* ) : null} */}
            </div>
          </div>
          <Typography className="font-medium fs12 gray28 ml30">
            Number of Records: {paymentsByFilter?.totalRecords ?? 0}
          </Typography>
          <Container maxWidth="xl">
            <Box className="pb30 mt10">
              <TableContainer sx={{ maxHeight: 400 }}>
                <Table
                  sx={{ minWidth: 200 }}
                  aria-labelledby="tableTitle"
                  stickyHeader
                >
                  <TableHead>
                    <TableRow>
                      {(selectedPaymentTab === "Pending"
                        ? pendingTableHeaders
                        : tableHeaders
                      ).map((hl, i) => (
                        <TableCell
                          key={i}
                          style={tblGrayBack}
                          sortDirection={false}
                          className="table-header-text"
                        >
                          <div style={{ width: "auto" }}>{nameExpan?.[hl]}</div>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {paymentsByFilter?.data?.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={12}
                        style={{ textAlign: "center", height: 100 }}
                      >
                        <div className="no-rec">No records available</div>
                      </TableCell>
                    </TableRow>
                  )}
                  <TableBody>
                    {reqTableList()?.map((pay, ind) => {
                      return (
                        <>
                          <TableRow tabIndex={-1} key={ind}>
                            {(selectedPaymentTab === "Pending"
                              ? pendingTableHeaders
                              : tableHeaders
                            ).map((th, index) => (
                              <TableCell
                                key={index + th + "tr"}
                                component="th"
                                className="table-text-black capitalize"
                              >
                                <div
                                  className="upload-row"
                                  style={{ width: "auto" }}
                                >
                                  {th === "petName" ? (
                                    <div>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Custom3dotString
                                          str={pay?.petName}
                                          className="txt-semi-bold capitalize fs14"
                                        />
                                      </div>
                                      {pay?.userName?.length > 0 ? (
                                        <div className="flex-row-ali-cen mt5">
                                          <Custom3dotString
                                            str={pay?.userName}
                                            className="txt-semi-bold capitalize fs12"
                                          />
                                        </div>
                                      ) : null}
                                    </div>
                                  ) : th === "vetName" ? (
                                    <div>
                                      {pay?.doctorName?.length > 0
                                        ? `${getRightSaluation(clinicVets, pay?.doctorId)}${
                                            pay?.doctorName
                                          }`
                                        : ""}
                                    </div>
                                  ) : th === "totalDue" ? (
                                    <div>
                                      {Number(pay?.totalAmt)?.toFixed(2)}
                                    </div>
                                  ) : th === "balanceDue" ? (
                                    <div>{Number(pay?.balDue)?.toFixed(2)}</div>
                                  ) : th === "payType" ? (
                                    <div className="table-text-black-semibold capitalize">
                                      {tabEnum?.[pay?.tab]}
                                      {/* {pay?.type === "Pharmacy" ||
                                      pay?.type === "Pet Shop"
                                        ? pay?.type
                                        : "Clinic"} */}
                                    </div>
                                  ) : th === "trDate" ? (
                                    <div>
                                      {moment(pay?.createdDate).format(
                                        "DD MMM YYYY",
                                      )}
                                    </div>
                                  ) : th === "paymentStatus" ? (
                                    <div className="table-status-row">
                                      <div
                                        className={`capitalize ${
                                          pay?.returned ||
                                          pay?.payStatus?.toLowerCase() ===
                                            "unpaid" ||
                                          pay?.payStatus?.toLowerCase() ===
                                            "cancelled"
                                            ? "table-text-red"
                                            : pay?.payStatus?.toLowerCase() ===
                                                "paid"
                                              ? "table-text-green"
                                              : "table-org-txt"
                                        }`}
                                      >
                                        {pay?.allStatusReturned &&
                                        pay?.allReturned
                                          ? "Returned"
                                          : pay?.payStatus ===
                                                "partiallypaid" ||
                                              pay?.payStatus ===
                                                "partially paid"
                                            ? "Partially Paid"
                                            : (pay?.payStatus ?? "Unpaid")}
                                      </div>
                                    </div>
                                  ) : th === "pay" ? (
                                    <div className="flex-row-ali-cen">
                                      <Typography
                                        className="black9 gray-back5 fs12 font-bold ph10 pv5 br5 cursor mr10"
                                        onClick={() =>
                                          onClickView(pay, pay?.totalAmt)
                                        }
                                      >
                                        View
                                      </Typography>
                                      {selectedPaymentTab === "Finalized" &&
                                        pay?.checked &&
                                        pay?.notFullyPaid &&
                                        pay?.balDue > 0 &&
                                        pay?.isNotCancelled &&
                                        !pay?.returned && (
                                          <Typography
                                            className="card-bot-green-back white-color fs12 font-bold ph10 pv5 br5 cursor mr10"
                                            onClick={() => {
                                              createModalOpen(pay, pay?.balDue);
                                            }}
                                          >
                                            Pay
                                          </Typography>
                                        )}
                                      {selectedPaymentTab === "Finalized" &&
                                        pay?.checked &&
                                        pay?.isNotCancelled &&
                                        pay?.enableCancel &&
                                        !pay?.returned && (
                                          <Typography
                                            className="card-bot-yellow-back white-color fs12 font-bold ph10 pv5 br5 cursor mr10"
                                            onClick={() => onCancelPayment(pay)}
                                          >
                                            Cancel
                                          </Typography>
                                        )}
                                      {/* {selectedPaymentTab === "Finalized" &&
                                        pay?.isCancelled && (
                                          <Typography className="red-back2 white-color fs12 font-bold ph10 pv5 br5 mr10">
                                            Cancelled
                                          </Typography>
                                        )} */}
                                      {selectedPaymentTab === "Finalized" &&
                                      pay?.checkOut ? (
                                        pay?.isCancelled ||
                                        !pay?.returnable ? null : (
                                          <Typography
                                            className="red5 red-back6 fs12 font-bold ph10 pv5 br5 cursor"
                                            onClick={() => handleReturns(pay)}
                                          >
                                            Return
                                          </Typography>
                                        )
                                      ) : null}
                                    </div>
                                  ) : (
                                    pay?.[th]
                                  )}
                                </div>
                              </TableCell>
                            ))}
                          </TableRow>
                          {/* {pay?.type === "Clinic" && !isBillCombined ? (
                            <div>
                              {getTreatmentRecordBasedType(
                                pay?.paymentDetails,
                                isBillCombined,
                              )?.length > 0 &&
                              pay?.treatmentInvoiceNumber?.length > 0 ? (
                                <TableRow tabIndex={-1} key={`${ind}_Treat`}>
                                  <TableCell
                                    component="th"
                                    className="table-text-black capitalize"
                                  >
                                    <div className="flex-row-ali-cen">
                                      {pay?.treatmentInvoiceNumber}
                                      <div className="ml10">
                                        Total: {pay?.totalAmt}
                                      </div>
                                      <div className="ml10">
                                        Balance Due: {pay?.balanceDue}
                                      </div>
                                    </div>
                                  </TableCell>
                                </TableRow>
                              ) : null}
                              {getPharmacyRecordBasedType(
                                pay?.paymentDetails,
                                isBillCombined,
                              )?.length > 0 &&
                              pay?.invoiceNumbers?.length > 0 ? (
                                <TableRow tabIndex={-1} key={`${ind}_Treat`}>
                                  <TableCell
                                    component="th"
                                    className="table-text-black capitalize"
                                  >
                                    <div className="flex-row-ali-cen">
                                      {pay?.invoiceNumbers}
                                      <div className="ml10">
                                        Total: {pay?.pharmacyTotalAmt}
                                      </div>
                                      <div className="ml10">
                                        Balance Due: {pay?.pharmacyBalanceDue}
                                      </div>
                                    </div>
                                  </TableCell>
                                </TableRow>
                              ) : null}
                              {getPetShopRecordBasedType(
                                pay?.paymentDetails,
                                isBillCombined,
                              )?.length > 0 &&
                              pay?.petShopInvoiceNumber?.length > 0 ? (
                                <TableRow tabIndex={-1} key={`${ind}_Treat`}>
                                  <TableCell
                                    component="th"
                                    className="table-text-black capitalize"
                                  >
                                    <div className="flex-row-ali-cen">
                                      {pay?.petShopInvoiceNumber}
                                      <div className="ml10">
                                        Total: {pay?.petShopTotalAmt}
                                      </div>
                                      <div className="ml10">
                                        Balance Due: {pay?.petShopBalanceDue}
                                      </div>
                                    </div>
                                  </TableCell>
                                </TableRow>
                              ) : null}
                            </div>
                          ) : null} */}
                        </>
                      );
                    })}
                  </TableBody>
                  {totalPage > 1 ? (
                    <TableFooter>
                      <TableRow>
                        <TableCell colSpan={12}>
                          <div className="flex-end">
                            <Pagination
                              count={totalPage}
                              variant="outlined"
                              color="primary"
                              page={page}
                              onChange={handleChangePage}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableFooter>
                  ) : null}
                </Table>
              </TableContainer>
            </Box>
          </Container>
        </>
      ) : null}

      {invModVisible ? (
        <BillingPreview
          selectedBill={selectedBill}
          modVsble={invModVisible}
          onClosePreview={handleInvModClose}
          billsToShow={["treatment", "pharmacy", "petshop"]}
        />
      ) : null}

      {payModalVisible ? (
        <CommonPayModal
          modVsble={payModalVisible}
          selectedBill={modalData}
          billsToShow={[billingTabEnum?.[modalData?.tab]]}
          // billsToShow={["TREATMENT", "PHARMACY", "PETSHOP"]}
          selectedTab={billingTabEnum?.[modalData?.tab]}
          onCloseMod={handleClosePayMod}
        />
      ) : null}

      <CustomModal
        open={genBillModVsble}
        onClose={onCloseGenBillMod}
        header=""
        modal
        modalWidth={35}
        headerShown={false}
      >
        <div className="mv10 mh20">
          <div className="txt-semi-bold fs16 flex-center">
            Are you sure you want to close the bill?
          </div>
          <div className="flex-center fs14 font-medium">
            No further changes can be made after this step.
          </div>
          <div className="flex-center fs14 font-medium">
            Please confirm to proceed.
          </div>
          <div className="flex-row-ali-cen flex-center mt10">
            <div>
              <CustomButton
                text="Confirm"
                redBtn
                smallBtn
                onClick={() => onGenerateBill(selectedBill, false)}
              />
            </div>
            <div className="ml20">
              <CustomButton
                text="Cancel"
                smallBtn
                onClick={onCloseGenBillMod}
              />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={cancelModVsble}
        onClose={onCloseCancelMod}
        header=""
        modal
        modalWidth={35}
        headerShown={false}
      >
        <div className="mv10 mh20">
          <div className="txt-semi-bold fs16 flex-center">
            Are you sure you want to cancel this invoice?
          </div>

          <div className="mt10">
            <CustomSelect
              list={getPersonInChargeList()}
              value={cancelValues?.personInCharge}
              handleChange={(e, value) => {
                onReasonChange("personInCharge", value);
              }}
              search
              fullWidth
              label="Person In charge"
              name="personInCharge"
              error={!!cancelValues?.inChargeErr}
              helperText={cancelValues?.inChargeErr}
            />
          </div>
          {Math.abs(selectedBill?.totalAmtPaid ?? 0) > 0 ? (
            <div className="mt10">
              <PaymentModeDropdown
                list={RefundTypes}
                value={cancelValues?.refundMethod}
                onChange={(e, value) => onReasonChange("refundMethod", e)}
                name="refundMethod"
                label="Refund Method"
                error={!!cancelValues?.refundMethodErr}
                helperText={cancelValues?.refundMethodErr}
              />
            </div>
          ) : null}
          <div className="mt10">
            <CustomSelect
              list={cancelReasons}
              value={cancelValues?.cancelReason}
              handleChange={(e, value) => onReasonChange("cancelReason", value)}
              search
              fullWidth
              label="Cancel Reason"
              name="cancelReason"
              error={!!cancelValues?.reasonErr}
              helperText={cancelValues?.reasonErr}
            />
          </div>
          <div className="mt10">
            <CustomTextField
              value={cancelValues?.cancelRemarks}
              handleChange={(e) =>
                onReasonChange("cancelRemarks", e?.target?.value)
              }
              fullWidth
              label="Remarks"
              labelTop
              name="cancelRemarks"
              multiline
              error={!!cancelValues?.remarkErr}
              helperText={cancelValues?.remarkErr}
            />
          </div>

          <div className="flex-row-ali-cen flex-center mt20">
            <div>
              <CustomButton
                text="Confirm"
                redBtn
                smallBtn
                onClick={onConfirmCancelMod}
              />
            </div>
            <div className="ml20">
              <CustomButton text="Cancel" smallBtn onClick={onCloseCancelMod} />
            </div>
          </div>
        </div>
      </CustomModal>
      <CustomModal
        open={returnModVsble}
        onClose={onCloseRetMod}
        header={!returnValue?.isInvoiceSelected ? "Process Return" : ""}
        modal={returnValue?.isInvoiceSelected}
        modalWidth={!returnValue?.isInvoiceSelected ? 30 : 90}
        rightModal={!returnValue?.isInvoiceSelected}
      >
        {!returnValue?.isInvoiceSelected ? (
          <div className="scroll-80vh ph20">
            <div>
              <Typography className="font-medium fs14">Return Type</Typography>
              <CustomSelect selectFixed value="Sales" label="" />
            </div>
            <div className="mt10">
              <Typography className="font-medium fs14">
                Customer Name
              </Typography>
              <CustomSelect
                selectFixed
                value={selectedBill?.userName ?? ""}
                label=""
              />
            </div>
            <div className="mt10">
              <Typography className="font-medium fs14">
                Select Invoice
              </Typography>
              <CustomSelect
                select
                value={returnValue?.selectedInvoiceNumber ?? ""}
                label=""
                list={getInvoiceNumbers()}
                handleChange={(e) =>
                  handleChange("selectedInvoiceNumber", e?.target?.value)
                }
              />
            </div>
            <div className="flex1-end mt20">
              <div>
                <CustomButton
                  smallBtn
                  text="Next"
                  onClick={() => handleChange("isInvoiceSelected", true)}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="scroll-80vh">
            <div className="return-back">
              <div className="flex-row-ali-cen ph40 mv15">
                <div className="w20Per">
                  <Typography className="gray29 fs12 font-medium">
                    Pet Name
                  </Typography>
                  <Typography className="fs14 black22 txt-semi-bold">
                    {selectedBill?.petName ?? ""}
                  </Typography>
                </div>
                <div className="w20Per">
                  <Typography className="gray29 fs12 font-medium">
                    Parent Name
                  </Typography>
                  <Typography className="fs14 black22 txt-semi-bold">
                    {selectedBill?.userName ?? ""}
                  </Typography>
                </div>
                <div className="w20Per">
                  <Typography className="gray29 fs12 font-medium">
                    Invoice number
                  </Typography>
                  <Typography className="fs14 black22 txt-semi-bold">
                    {returnValue?.selectedInvoiceNumber}
                    {/* {[
                      selectedBill?.invoiceNumbers ?? "",
                      selectedBill?.treatmentInvoiceNumber ?? "",
                      selectedBill?.petShopInvoiceNumber ?? "",
                    ]
                      ?.filter(Boolean)
                      ?.join(", ")} */}
                  </Typography>
                </div>
                <div className="w20Per">
                  <Typography className="gray29 fs12 font-medium">
                    Invoice date
                  </Typography>
                  <Typography className="fs14 black22 txt-semi-bold">
                    {moment(new Date(selectedBill?.createdDate)).format(
                      "DD MMM YYYY",
                    )}
                  </Typography>
                </div>
                <div className="w20Per">
                  <Typography className="gray29 fs12 font-medium">
                    Amount Received
                  </Typography>
                  <Typography className="fs14 black22 txt-semi-bold">
                    {Number(
                      selectedBill?.tab === "petShop"
                        ? (selectedBill?.petShopAmtPaid ?? 0)
                        : selectedBill?.tab === "pharmacy"
                          ? (selectedBill?.pharmacyAmtPaid ?? 0)
                          : (selectedBill?.amtPaid ?? 0),
                    )}
                  </Typography>
                </div>
              </div>
            </div>
            <div className="flex-row-ali-cen mt20 ph10">
              <div className="w25Per">
                <Typography className="txt-semi-bold fs12 blue-color">
                  Service/Item Name
                </Typography>
              </div>
              <div className="w15Per">
                <Typography className="txt-semi-bold fs12 blue-color">
                  Available Qty
                </Typography>
              </div>
              <div className="w15Per">
                <Typography className="txt-semi-bold fs12 blue-color">
                  Returning Qty
                </Typography>
              </div>
              <div className="w15Per">
                <Typography className="txt-semi-bold fs12 blue-color">
                  Unit Price
                </Typography>
              </div>
              <div className="w15Per">
                <Typography className="txt-semi-bold fs12 blue-color">
                  Refundable Taxes
                </Typography>
              </div>
              <div className="w15Per">
                <Typography className="txt-semi-bold fs12 blue-color">
                  Refund Total
                </Typography>
              </div>
            </div>
            <div className="blue-hor-split mt5" />
            {returnValue?.list?.map((li, i) => {
              const taxVal = Number(li?.tax) / Number(li?.quantity);
              return (
                <div className="plan-bor mt10 flex-row-ali-cen" key={`${i} li`}>
                  <div className="w25Per pr10">
                    <Custom3dotString
                      className="txt-regular fs12 gray30"
                      str={li?.name}
                      length={25}
                    />
                  </div>
                  <div className="w15Per pr10">
                    <Typography className="txt-regular fs12 gray30">
                      {li?.returnableQuantity} {li?.uomName ?? ""}
                    </Typography>
                  </div>
                  <div className="w15Per pr10">
                    <CustomTextField
                      value={li?.returnQuantity}
                      error={!!li?.returnQuantityErr}
                      helperText={li?.returnQuantityErr}
                      fullWidth
                      endIcon
                      inputIcon={li?.uomName ?? ""}
                      handleChange={(e) =>
                        handleChangeRetQty(e?.target?.value, i)
                      }
                      disabled={returnValue?.isCancel}
                    />
                  </div>
                  <div className="w15Per pr10">
                    <Typography className="txt-regular fs12 gray30">
                      Rs {Number(li?.mrpPrice)?.toFixed(2)}
                    </Typography>
                  </div>
                  <div className="w15Per pr10">
                    <Typography className="txt-regular fs12 gray30">
                      Rs {Number(taxVal) > 0 ? Number(taxVal)?.toFixed(2) : 0}
                    </Typography>
                  </div>
                  <div className="w15Per">
                    <Typography className="txt-regular fs12 gray30">
                      Rs{" "}
                      {Number(
                        Number(li?.returnQuantity ?? 0) *
                          Number(li?.mrpPrice ?? 0),
                      )?.toFixed(2)}{" "}
                    </Typography>
                  </div>
                </div>
              );
            })}
            {listNotValid ? (
              <FormHelperText error className="flex-center mt10">
                Enter quantity for atleast one item
              </FormHelperText>
            ) : null}
            <div className="flex-row mt30">
              <div className="w30Per">
                <div className="flex-column">
                  <div>
                    <CustomSelect
                      list={getPersonInChargeList()}
                      value={returnValue?.personInCharge}
                      handleChange={(e, value) => {
                        handleChange("personInCharge", value);
                      }}
                      search
                      fullWidth
                      label="Person In charge"
                      name="personInCharge"
                      error={!!returnValue?.inChargeErr}
                      helperText={returnValue?.inChargeErr}
                    />
                  </div>
                  {Number(
                    selectedBill?.tab === "petShop"
                      ? (selectedBill?.petShopAmtPaid ?? 0)
                      : selectedBill?.tab === "pharmacy"
                        ? (selectedBill?.pharmacyAmtPaid ?? 0)
                        : (selectedBill?.amtPaid ?? 0),
                  ) > 0 ? (
                    <div className="mt10">
                      <PaymentModeDropdown
                        list={RefundTypes}
                        value={returnValue?.refundMethod}
                        onChange={(e, value) => handleChange("refundMethod", e)}
                        name="refundMethod"
                        label="Refund Method"
                        error={!!returnValue?.refundMethodErr}
                        helperText={returnValue?.refundMethodErr}
                      />
                    </div>
                  ) : null}
                  <div className="mt10">
                    <CustomSelect
                      list={returnReasons}
                      value={returnValue?.returnReason}
                      handleChange={(e, value) =>
                        handleChange("returnReason", value)
                      }
                      search
                      fullWidth
                      label="Return Reason"
                      name="returnReason"
                      error={!!returnValue?.reasonErr}
                      helperText={returnValue?.reasonErr}
                    />
                  </div>
                  <div className="mt10">
                    <CustomTextField
                      value={returnValue?.remarks}
                      handleChange={(e) =>
                        handleChange("remarks", e?.target?.value)
                      }
                      fullWidth
                      label="Remarks"
                      labelTop
                      name="remarks"
                      multiline
                    />
                  </div>
                </div>
              </div>
              <div className="flex1-end">
                <div className="w50Per">
                  <div className="flex-column">
                    <div className="flex-row-ali-cen">
                      <div className="w60Per">
                        <Typography className="black23 font-medium fs14">
                          Refund Subtotal
                        </Typography>
                      </div>
                      <div className="w40Per">
                        <Typography className="black23 font-medium fs14">
                          Rs.{" -"}
                          {Number(
                            Number(
                              getRefundValuesNew(returnValue?.list)?.subTotal ??
                                0,
                            ),
                          )?.toFixed(2)}
                        </Typography>
                      </div>
                    </div>
                    <div className="flex-row-ali-cen mt10">
                      <div className="w60Per">
                        <Typography className="black23 font-medium fs14">
                          Refundable Taxes
                        </Typography>
                      </div>
                      <div className="w40Per">
                        <Typography className="black23 font-medium fs14">
                          Rs.{" -"}
                          {Number(getRefundValuesNew(returnValue?.list)?.tax) >
                          0
                            ? Number(
                                getRefundValuesNew(returnValue?.list)?.tax,
                              )?.toFixed(2)
                            : 0}
                        </Typography>
                      </div>
                    </div>

                    <div className="flex-row-ali-cen ref-ttl mt30">
                      <div className="w60Per">
                        <Typography className="blue-color txt-semi-bold fs14">
                          Refund Total
                        </Typography>
                      </div>
                      <div className="w40Per">
                        <Typography className="blue-color font-bold fs14">
                          Rs.{" -"}
                          {Number(
                            getRefundValuesNew(returnValue?.list)?.total,
                          )?.toFixed(2)}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex1-end mt20">
              {returnValue?.isCancel ? null : (
                <div>
                  <CustomButton
                    text="Save As Draft"
                    smallBtn
                    onClick={() => submitReturn("draft")}
                  />
                </div>
              )}
              <div className="ml10">
                <CustomButton
                  text="Submit"
                  smallBtn
                  onClick={() => submitReturn("credit")}
                />
              </div>
            </div>
          </div>
        )}
      </CustomModal>

      <CustomModal
        open={filterValues?.visible}
        onClose={onCloseFilter}
        header="Filter"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="gray38 fs12 txt-regular">
                Filter by:
              </Typography>
              {!filterValues?.added ? (
                (selectedPaymentTab === "Pending"
                  ? filterByListOpen
                  : filterByList
                )?.map((li, i) => (
                  <div className="flex-row-ali-cen" key={`${i}_li`}>
                    <div>
                      <CustomCheckbox
                        checked={filterValues?.selectedList?.includes(li)}
                        onChange={() => onSelectFilter(li)}
                      />
                    </div>
                    <Typography className="txt-regular fs14 black mb5 mlMin15">
                      {li}
                    </Typography>
                  </div>
                ))
              ) : (
                <div>
                  <div
                    className="flex-row-ali-cen gray-back4 ph10 pv10 br10 width-fit-con mt10 cursor"
                    onClick={() => onFilterAdd(false)}
                  >
                    <AddIcon
                      sx={{ color: AppColors.appPrimary, fontSize: 15 }}
                    />
                    <Typography className="font-medium fs12 blue-color ml5">
                      Add Filter
                    </Typography>
                  </div>
                  <div>
                    {filterValues?.selectedList?.map((li) => (
                      <div className="mt20">
                        {dropFields?.includes(li) ? (
                          <CustomSelect
                            list={
                              li === "Invoice Type"
                                ? paymentInvoiceTypeList
                                : li === "Person In Charge"
                                  ? getClinicVetList()
                                  : li === "Payment Mode"
                                    ? getPaymentMethodList()
                                    : []
                            }
                            value={filterValues?.values?.[li] ?? []}
                            name={li}
                            handleChange={onFilterValuesChange}
                            label={li}
                            multiSelectSearchCheck={li !== "Person In Charge"}
                            select={li === "Person In Charge"}
                          />
                        ) : splitRows?.includes(li) ? (
                          <div className="flex-row-between-align-center">
                            <div className="w45Per">
                              <CustomTextField
                                placeholder={getFieldName(li, "start")}
                                fullWidth
                                name={getFieldName(li, "start")}
                                handleChange={onFilterValuesChange}
                                value={
                                  filterValues?.values?.[
                                    getFieldName(li, "start")
                                  ]
                                }
                                type="number"
                                label={getFieldName(li, "start")}
                                mobileDate={li === "Transaction Date"}
                              />
                            </div>
                            <div className="w45Per">
                              <CustomTextField
                                placeholder={getFieldName(li, "end")}
                                fullWidth
                                name={getFieldName(li, "end")}
                                handleChange={onFilterValuesChange}
                                value={
                                  filterValues?.values?.[
                                    getFieldName(li, "end")
                                  ]
                                }
                                type="number"
                                label={getFieldName(li, "end")}
                                mobileDate={li === "Transaction Date"}
                              />
                            </div>
                          </div>
                        ) : (
                          <CustomTextField
                            placeholder={li}
                            fullWidth
                            name={li}
                            handleChange={onFilterValuesChange}
                            value={filterValues?.values?.[li] ?? ""}
                            label={li}
                            suggetions
                            options={getSuggestionList()}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {!filterValues?.added ? (
                <div className="flex1-end mt15">
                  <div>
                    <CustomButton
                      text="Add"
                      smallBtn
                      onClick={() => onFilterAdd(true)}
                    />
                  </div>
                </div>
              ) : (
                <div className="flex-row-center mt15">
                  <div>
                    <CustomButton
                      text="Reset All"
                      smallBtn
                      onClick={onFilterReset}
                      tabSelectdBtn
                    />
                  </div>
                  <div className="ml20">
                    <CustomButton
                      text="Apply Filters"
                      smallBtn
                      onClick={onApplyFilter}
                    />
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      </CustomModal>
    </>
  );
};

export default Payments;
